/* eslint-disable no-prototype-builtins */
// src/api/smart/convert.js
// Temporary empty action — will be expanded later
function guilgee_balanceAction(data = {}) {
  console.log('data', data);

  // The mapping object you provided
  const mapping = {
    dans_ner: 'AccountName',
    dans_dugaar: 'AccountId',
    valiut_torol: 'CurrencyId',
    deb_eh: 'BeginDebitAmt',
    cred_eh: 'BeginCreditAmt',
    guilgee_deb: 'DebitAmt',
    guilgee_cred: 'CreditAmt', // ← fixed: was wrongly "EndCreditAmt" in your example
    dans_dun_deb: 'EndDebitAmt',
    dans_dun_cred: 'EndCreditAmt', // ← fixed: was wrongly "BeginCreditAmtFc"
    dans_dun_valiut_deb: 'EndDebitAmtFc',
    dans_dun_valiut_cred: 'EndCreditAmtFc',
    dans_angilal: '', // empty on purpose
  };

  // Invert the mapping: English key → Mongolian key
  const reverseMap = {};
  Object.keys(mapping).forEach((mongolKey) => {
    const englishKey = mapping[mongolKey];
    if (englishKey) {
      reverseMap[englishKey] = mongolKey;
    }
  });

  // If data is an array of accounts (most common case)
  if (Array.isArray(data)) {
    return data.map((item) => {
      const converted = {};
      Object.keys(item).forEach((engKey) => {
        const mongolKey = reverseMap[engKey];
        if (mongolKey) {
          converted[mongolKey] = item[engKey];
        } else {
          // keep original key if not in mapping (optional)
          converted[engKey] = item[engKey];
        }
      });
      // Always add empty dans_angilal if it's missing
      if (!converted.hasOwnProperty('dans_angilal')) {
        converted.dans_angilal = '';
      }
      return converted;
    });
  }

  // Fallback: single object (not array)
  const converted = {};
  Object.keys(data).forEach((engKey) => {
    const mongolKey = reverseMap[engKey];
    if (mongolKey) {
      converted[mongolKey] = data[engKey];
    } else {
      converted[engKey] = data[engKey];
    }
  });
  if (!converted.hasOwnProperty('dans_angilal')) {
    converted.dans_angilal = '';
  }

  return converted;
}

function avalga_uglugAction(data = [], params = {}) {
  // Optional: force file_type from params, otherwise auto-detect from data
  const forcedFileType = params.file_type; // "avlagiin_tovchoo" or "oglogiin_tovchoo"

  // Mapping: Mongolian field → Original English key
  const mapping = {
    dans_code: 'AccountId',
    dans_ner: 'AccountName',
    hariltsagch_code: 'CustomerId',
    hariltsagch_ner: 'CustomerName',
    dans_dun_cred: 'DebitAmt', // Эцсийн үлдэгдэл кредит (MNT)
    dans_dun_deb: 'CreditAmt', // Эцсийн үлдэгдэл дебет (MNT)
    ets_uld: 'EndBal', // Эцсийн үлдэгдэл (MNT)
    ets_uld_valiut: 'EndBalFc', // Эцсийн үлдэгдэл (валиут)
  };

  // Ensure input is array
  const list = Array.isArray(data) ? data : [data];

  // Filter and convert
  const result = list
    .filter((item) => {
      if (!item || !item.AccountType) return false;

      // If forced file_type is given → filter by it
      if (forcedFileType === 'avlagiin_tovchoo') {
        return item.AccountType === 'RCV';
      }
      if (forcedFileType === 'oglogiin_tovchoo') {
        return item.AccountType === 'PBL';
      }

      // Otherwise include both RCV and PBL
      return item.AccountType === 'RCV' || item.AccountType === 'PBL';
    })
    .map((item) => {
      const converted = {};

      // Map fields
      Object.keys(mapping).forEach((mongolKey) => {
        const engKey = mapping[mongolKey];
        if (item.hasOwnProperty(engKey)) {
          converted[mongolKey] = item[engKey] || 0;
        }
      });

      // Add type info
      if (item.AccountType === 'RCV') {
        converted.file_type = 'avlagiin_tovchoo';
        converted.type_name = 'Авлагын төвчөө';
      } else if (item.AccountType === 'PBL') {
        converted.file_type = 'oglogiin_tovchoo';
        converted.type_name = 'Өглөгийн төвчөө';
      }

      return converted;
    });

  return result;
}

function undsen_hurunguAction(data = []) {
  const mapping = {
    dans_code: 'AccountId',
    kod: 'AssetTypeId',
    burtgel_dugaar: 'AssetId',
    hurungu_ner: 'AssetTypeName',
    hemjih_negj: 'MeasureName',
    ashig_ehleh_ognoo: 'BeginUsedDate',
    ashiglah_jil: 'UsageYear', // <-- renamed to ashiglah_jil
    ets_uld_too_hemjee: 'EndQty',
    ets_uld_ortog: 'EndAmt',
    ets_uld_elegdel: 'DeprEndAmt',
  };

  // Helper: convert ISO date string to YYYY/MM/DD or null if invalid/default
  function formatDate(isoString) {
    if (!isoString || isoString.startsWith('0001-01-01')) {
      return '2000/01/01'; // or "" if you prefer
    }

    const date = new Date(isoString);
    if (isNaN(date.getTime())) return null;

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');

    return `${year}/${month}/${day}`;
  }

  const list = Array.isArray(data) ? data : [data];

  // Grouped result by dans_code
  const groupedByDansCode = {};

  list.forEach((item) => {
    const converted = {};

    Object.keys(mapping).forEach((mongolKey) => {
      const engKey = mapping[mongolKey];
      let value = item[engKey];

      if (engKey === 'BeginUsedDate') {
        value = formatDate(value);
      }

      converted[mongolKey] = value ?? null;
    });

    const { dans_code, ...rest } = converted;

    if (!dans_code) {
      // If AccountId is missing, skip or handle differently if needed
      return;
    }

    if (!groupedByDansCode[dans_code]) {
      groupedByDansCode[dans_code] = {
        dans_code,
        dans: [],
      };
    }

    // Push row into its "dans" array (without repeating dans_code)
    groupedByDansCode[dans_code].dans.push({
      kod: rest.kod,
      hurungu_ner: rest.hurungu_ner,
      burtgel_dugaar: rest.burtgel_dugaar,
      hemjih_negj: rest.hemjih_negj,
      ashiglah_jil: rest.ashiglah_jil,
      ashig_ehleh_ognoo: rest.ashig_ehleh_ognoo,
      ets_uld_too_hemjee: rest.ets_uld_too_hemjee,
      ets_uld_ortog: rest.ets_uld_ortog,
      ets_uld_elegdel: rest.ets_uld_elegdel,
    });
  });

  // Final array form:
  return Object.values(groupedByDansCode);
}

// Function to transform journal/transaction data into the required format
// Excludes items where DocumentType is "ClosingJournal"
function guilgee_jagsaaltAction(Data = {}) {
  // If no valid data → return empty array
  if (!Array.isArray(Data) || Data.length === 0) {
    return [];
  }

  const result = [];

  Data.forEach((item) => {
    // Skip closing journal entries
    if (item.DocumentType === 'ClosingJournal') {
      return;
    }

    // Parse date → yyyy/mm/dd
    const dateObj = new Date(item.DocumentDate);
    const year = dateObj.getFullYear();
    const month = String(dateObj.getMonth() + 1).padStart(2, '0');
    const day = String(dateObj.getDate()).padStart(2, '0');
    const date = `${year}/${month}/${day}`;

    // Common values
    const desc = item.DocumentDesc || '';
    // const cur_type = item.DebitCurrencyId || item.CreditCurrencyId || 'MNT';
    const cur_type_deb = item.DebitCurrencyId || 'MNT';
    const cur_type_cred = item.CreditCurrencyId || 'MNT';
    // Debit side values
    const deb = Number(item.DebitAmt || 0);
    const deb_fc = Number(item.DebitAmtFc || 0);
    const deb_rate = Number(item.DebitRate || 1);
    const deb_name = item.DebitAccountName || '';

    // Credit side values
    const cred = Number(item.CreditAmt || 0);
    const cred_fc = Number(item.CreditAmtFc || 0);
    const cred_rate = Number(item.CreditRate || 1);
    const cred_name = item.CreditAccountName || '';

    // We usually take the rate from the side that has movement
    // But in most Mongolian accounting exports both sides have same rate
    // const used_rate = deb_rate !== 1 ? deb_rate : cred_rate;
    // const cur_rate = Number(used_rate.toFixed(6));

    // Debit row
    result.push({
      date,
      account_name: deb_name,
      account_code: item.DebitAccountId || '',
      account_code_rec: item.CreditAccountId || '',
      desc,
      cur_type: cur_type_deb,
      cur_rate: deb_rate,
      cur_value: Number(deb_fc.toFixed(6)), // DebitAmtFc
      deb: Number(deb.toFixed(6)),
      cred: 0,
    });

    // Credit row
    result.push({
      date,
      account_name: cred_name,
      account_code: item.CreditAccountId || '',
      account_code_rec: item.DebitAccountId || '',
      desc,
      cur_type: cur_type_cred,
      cur_rate: cred_rate,
      cur_value: Number(cred_fc.toFixed(6)), // CreditAmtFc
      deb: 0,
      cred: Number(cred.toFixed(6)),
    });
  });

  return result;
}

// Function to transform fixed asset (Үндсэн хөрөнгө) document data into the required list format
function undsen_hurungi_jagsaaltAction(Data = {}) {
  // Extract the Data array

  // If no data, return empty array
  if (!Array.isArray(Data) || Data.length === 0) {
    return [];
  }
  const list = Data.map((item) => {
    // Format date as yyyy/mm/dd (using DocumentDate)
    const dateObj = new Date(item.DocumentDate);
    const year = dateObj.getFullYear();
    const month = String(dateObj.getMonth() + 1).padStart(2, '0');
    const day = String(dateObj.getDate()).padStart(2, '0');
    const date = `${year}/${month}/${day}`;

    // Quantities
    const debQt = Number(item.DebitQty || 0);
    const credQt = Number(item.CreditQty || 0);

    // Amounts in MNT
    const deb = Number(item.DebitAmt || 0);
    const cred = Number(item.CreditAmt || 0);

    return {
      account_code: item.AssetAccountId || '', // Дансны дугаар
      asset_dugaar: item.AssetId || '', // Бүртгэлийн дугаар
      asset_code: item.AssetTypeId || '', // Хөрөнгийн код
      asset_name: item.AssetTypeName || '', // Хөрөнгийн нэр (here using location name as descriptive field; adjust if needed)
      date, // Гүйлгээний огноо
      desc: item.DocumentDesc || '', // Гүйлгээний утга
      deb_qt: Number(debQt.toFixed(6)), // Дебит тоо ширхэг
      deb: Number(deb.toFixed(6)), // Дебит дүн (MNT)
      cred_qt: Number(credQt.toFixed(6)), // Кредит тоо ширхэг
      cred: Number(cred.toFixed(6)), // Кредит дүн (MNT)
    };
  }).filter((item) => item.account_code !== '' && item.asset_code !== ''); // Filter out entries with no account_code and no asset_code
  return list;
}
// Function for Авлага/Өглөг (Receivables/Payables) transaction list
// Function for Авлага/Өглөг (Receivables/Payables) transaction list
// Excludes entries where DocumentType is "ClosingJournal"
function avlag_uglug_jagsaaltAction(Data = {}) {
  if (!Array.isArray(Data) || Data.length === 0) {
    return [];
  }

  const result = [];

  Data.forEach((item) => {
    if (
      item.DocumentType === 'ClosingJournal' &&
      item.DebitType !== 'RCV' &&
      item.DebitType !== 'PBL' &&
      item.CreditType !== 'RCV' &&
      item.CreditType !== 'PBL'
    ) {
      return;
    }

    const debitCur = item.DebitCurrencyId || 'MNT';
    const creditCur = item.CreditCurrencyId || 'MNT';

    // Skip pure MNT transactions
    if (debitCur === 'MNT' && creditCur === 'MNT') {
      return;
    }

    const date = new Date(item.DocumentDate)
      .toISOString()
      .slice(0, 10)
      .replace(/-/g, '/');

    const desc = item.DocumentDesc || '';

    const cred_rate = Number(item.CreditRate || 1);
    const deb_rate = Number(item.DebitRate || 1);

    const client_code = item.DebitCustomerId || item.CreditCustomerId || '';
    const client_name = item.DebitCustomerName || item.CreditCustomerName || '';
    // item.DebitAccountId start with '12' or '31'
    const DebitStart = item.DebitAccountId
      ? item.DebitAccountId.toString().startsWith('12') ||
        item.DebitAccountId.toString().startsWith('31')
      : false;

    // item.CreditAccountId start with '12' or '31'
    const CreditStart = item.CreditAccountId
      ? item.CreditAccountId.toString().startsWith('12') ||
        item.CreditAccountId.toString().startsWith('31')
      : false;
    // Debit row

    if (
      DebitStart &&
      (Number(item.DebitAmt || 0) > 0 || Number(item.DebitAmtFc || 0) > 0)
    ) {
      result.push({
        account_code: item.DebitAccountId || '',
        client_code,
        client_name,
        date,
        desc,
        cur_type: debitCur,
        cur_deb: Number((item.DebitAmtFc || 0).toFixed(6)),
        cur_cred: 0,
        cur_rate: deb_rate,
        mnt_deb: Number((item.DebitAmt || 0).toFixed(6)),
        mnt_cred: 0,
      });
    }

    // Credit row
    if (
      CreditStart &&
      (Number(item.CreditAmt || 0) > 0 || Number(item.CreditAmtFc || 0) > 0)
    ) {
      result.push({
        account_code: item.CreditAccountId || '',
        client_code,
        client_name,
        date,
        desc,
        cur_type: creditCur,
        cur_deb: 0,
        cur_cred: Number((item.CreditAmtFc || 0).toFixed(6)),
        cur_rate: cred_rate,
        mnt_deb: 0,
        mnt_cred: Number((item.CreditAmt || 0).toFixed(6)),
      });
    }
  });

  return result;
}

export function convertAction(actionKey, data = {}, params = {}) {
  const convertedData = {};

  if (actionKey === 'guilgee_balance') {
    // Call specific conversion function
    return guilgee_balanceAction(data);
  }
  if (actionKey === 'avalga_uglug') {
    return avalga_uglugAction(data, params);
  }
  if (actionKey === 'undsen_hurungu') {
    return undsen_hurunguAction(data);
  }
  if (actionKey === 'guilgee_jagsaalt') {
    return guilgee_jagsaaltAction(data);
  }
  if (actionKey === 'undsen_hurungi_jagsaalt') {
    return undsen_hurungi_jagsaaltAction(data);
  }
  if (actionKey === 'avlag_uglug_jagsaalt') {
    return avlag_uglug_jagsaaltAction(data);
  }
  return convertedData;
}
